import { render, staticRenderFns } from "./HorizontalProductList.vue?vue&type=template&id=11a6298c&scoped=true&"
import script from "./HorizontalProductList.vue?vue&type=script&lang=js&"
export * from "./HorizontalProductList.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalProductList.vue?vue&type=style&index=0&id=11a6298c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6298c",
  null
  
)

export default component.exports